export const emptyCustomer = () => ({
    id: "",
    companyName: "",
    name: "",
    lastname: "",
    email: "",
    phone: "",
    addresses: [],
    bankConnections: [],
    taxData: {
        taxNumber: "",
        vatNumber: "",
        ustId: "",
        economicId: "",
        smallBusiness: false,
    },
});

export const normalizeTaxData = (taxData = {}) => ({
    taxNumber: "",
    vatNumber: "",
    ustId: "",
    economicId: "",
    smallBusiness: false,
    ...taxData,
});

export const normalizeCustomer = (customer = {}) => ({
    ...customer,
    taxData: normalizeTaxData(customer?.taxData || {}),
});

export const buildCustomerPayload = (customer) => {
    const name = (customer.name || "").trim();
    const lastname = (customer.lastname || "").trim();
    const companyName = (customer.companyName || "").trim();

    return {
        ...customer,
        name,
        lastname,
        companyName: companyName || (!lastname && name ? name : ""),
        taxData: normalizeTaxData(customer.taxData),
    };
};
